export default function SuccessCard({ success }) {
  if (!success) return null;

  const warnings = success.provisioning_warnings || [];

  return (
    <div className="mb-5 space-y-3">
      <div className="rounded-2xl border border-emerald-300 bg-emerald-50 p-4">
        <div className="font-medium text-emerald-900">{success.message}</div>

        <div className="text-sm text-emerald-900/90 mt-3 grid gap-1">
          <div>
            <span className="font-medium">Owner email:</span> {success.email}
          </div>
          {success.clinic_name && (
            <div>
              <span className="font-medium">Clinic:</span> {success.clinic_name}
            </div>
          )}
          {success.clinic_id && (
            <div>
              <span className="font-medium">Clinic ID:</span> {success.clinic_id}
            </div>
          )}
          {success.preferred_timezone && (
            <div>
              <span className="font-medium">Timezone:</span>{" "}
              {success.preferred_timezone}
            </div>
          )}
          {success.assigned_phone_number && (
            <div className="flex items-center gap-1.5">
              <span className="inline-block h-2 w-2 rounded-full bg-emerald-500" />
              <span className="font-medium">Phone (auto-provisioned):</span>{" "}
              {success.assigned_phone_number}
            </div>
          )}
          {success.elevenlabs_agent_id && (
            <div className="flex items-center gap-1.5">
              <span className="inline-block h-2 w-2 rounded-full bg-emerald-500" />
              <span className="font-medium">Agent ID:</span>{" "}
              {success.elevenlabs_agent_id}
            </div>
          )}
        </div>
      </div>

      {warnings.length > 0 && (
        <div className="rounded-2xl border border-amber-300 bg-amber-50 p-4">
          <div className="font-medium text-amber-900">Provisioning warnings</div>
          <ul className="mt-2 list-disc pl-5 text-sm text-amber-800 space-y-1">
            {warnings.map((w, i) => (
              <li key={i}>{w}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
